import type { AddFlagProps } from '@databases/flags/types';

import { MentionFlagForMultipleUsers } from './mentionFlagForMultipleUsers';
import { MentionFlagForSingleUser } from './mentionFlagForSingleUser';
import { MentionFlagForTwoUsers } from './mentionFlagForTwoUsers';
import { RestrictionsFlagForMultipleUsers } from './restrictionsFlagForMultipleUsers';
import { RestrictionsFlagForSingleUser } from './restrictionsFlagForSingleUser';
import { RestrictionsFlagForTwoUsers } from './restrictionsFlagForTwoUsers';
import { MentionBuilder, BuildProps } from './types';

const MentionBuilderClasses: { new (): MentionBuilder }[] = [
  MentionFlagForMultipleUsers,
  MentionFlagForSingleUser,
  MentionFlagForTwoUsers,
  RestrictionsFlagForMultipleUsers,
  RestrictionsFlagForSingleUser,
  RestrictionsFlagForTwoUsers,
];

export function buildFlagForMentions({
  formatMessage,
  usersWithAccess,
  usersWithoutAccess,
  isLocked,
  showPanel,
  fieldId,
}: BuildProps): AddFlagProps[] {
  const flagData = [];
  for (const MentionBuilder of MentionBuilderClasses) {
    const mentionBuilder = new MentionBuilder();

    if (!mentionBuilder.shouldShowFlag({ usersWithAccess, usersWithoutAccess })) {
      continue;
    }

    const buildFlagData = mentionBuilder.build({
      formatMessage,
      usersWithAccess,
      usersWithoutAccess,
      isLocked,
      showPanel,
      fieldId,
    });

    flagData.push(buildFlagData);
  }

  return flagData;
}
